import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class FanPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.fanRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.fanImport,
    );
    this.fanAutocomplete = permissionChecker.match(
      Permissions.values.fanAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.fanCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.fanEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.fanDestroy,
    );
  }
}
